import { RepositoryPickerActions } from "DistributedTaskControls/Actions/RepositoryPickerActions";
import { ActionsHubManager } from "DistributedTaskControls/Common/Actions/ActionsHubManager";
import { ActionCreatorBase } from "DistributedTaskControls/Common/Actions/Base";
import {
    ActionCreatorKeys
} from "DistributedTaskControls/SharedControls/InputControls/RepositoryPickerConstants";

export class RepositoryPickerActionCreator extends ActionCreatorBase {

    constructor() {
        super();
    }

    public initialize(instanceId: string): void {
        this._actions = ActionsHubManager.GetActionsHub<RepositoryPickerActions>(RepositoryPickerActions, instanceId);
    }

    public static getKey(): string {
        return ActionCreatorKeys.RepositoryPicker;
    }

    public updateValue(value: string): void {
        this._actions.updateValue.invoke(value);
    }

    public updateShowRepositorySelectorDialog(showRepositorySelectorDialog: boolean): void {
        this._actions.updateShowRepositorySelectorDialog.invoke(showRepositorySelectorDialog);
    }

    private _actions: RepositoryPickerActions;
}
